import type { FunctionComponent } from "react"

import { useEffect } from "react"

import { logger } from "@/modules/monitoring/logger"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

export const CheckCdnAccess: FunctionComponent = () => {
  const { dataCurrentUser, isSuccessCurrentUser } = useCurrentUserFetch()
  const currentUserRole = dataCurrentUser?.attributes?.roleTitle || "unknown"
  const companyPermalink = dataCurrentUser?.attributes?.companyPermalink || "unknown"

  useEffect(() => {
    if (!isSuccessCurrentUser) {
      return
    }

    const logMessage = `Unreachable jobteasercdn asset from "${window.location.hostname}" for role "${currentUserRole}" and companyPermalink "${companyPermalink}" (HREF ${window.location.href})`

    // eslint-disable-next-line no-restricted-globals
    fetch("https://static-assets.jobteasercdn.com/next-jobteaser/production/favicon.ico?cachebust=1")
      .then(res => {
        if (!res.ok) {
          logger.error(`${logMessage} - status ${res.status}`)
        }
        return null
      })
      .catch(err => {
        logger.error(`${logMessage} - err ${err.message}`)
        return null
      })
  }, [currentUserRole, isSuccessCurrentUser])

  return null
}
